import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { Alert, Snackbar } from '@mui/material';
import { useJobFlowTracking } from '../../hooks/useJobFlowTracking';
import { updateJob } from '../../Redux/ActionCreators/jobsAction';
import InviteCandidatesV2 from '../InviteCandidatesV2/InviteCandidatesV2';

const ACTIVE_STATUS_ID = "14107328-840b-4ad0-904f-8a2243720f70";

// Final wizard step: publishes the job (draft → active), then shows the invite
// workspace in create-flow mode. The workspace mounts only after publishing so
// its links, and the candidate chat behind "Try it", run against a live job.
// The step counts as completed once candidates are added or the user moves on
// to the pipeline.
function Stage3InviteCandidates({ jobId, flowSessionId }) {
    const dispatch = useDispatch();
    const [publishing, setPublishing] = useState(true);
    const [snack, setSnack] = useState({ open: false, message: '', severity: 'warning' });
    const hasPublished = useRef(false);

    const { trackComplete } = useJobFlowTracking({
        flowSessionId,
        stepId: 'invite_candidates',
        stepLabel: 'Invite Candidates',
        jobId,
    });

    useEffect(() => {
        if (!jobId || hasPublished.current) return;
        hasPublished.current = true;

        const publishJob = async () => {
            const result = await dispatch(updateJob(jobId, { job_status_id: ACTIVE_STATUS_ID }));
            if (result?.__error402) {
                setSnack({ open: true, message: 'Active jobs limit reached.', severity: 'warning' });
            } else if (!result || result.success === false) {
                setSnack({ open: true, message: 'Failed to publish the job.', severity: 'error' });
            }
            setPublishing(false);
        };
        publishJob();
    }, [dispatch, jobId]);

    const complete = () => trackComplete(jobId);

    return (
        <>
            {publishing ? (
                <div className="cj-publishing">
                    <p className="gradient-text-loading">Publishing your job, please wait..</p>
                </div>
            ) : (
                <InviteCandidatesV2
                    jobId={jobId}
                    inCreateFlow
                    onInvited={complete}
                    onViewProgress={complete}
                />
            )}

            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={snack.open}
                autoHideDuration={4000}
                onClose={() => setSnack(prev => ({ ...prev, open: false }))}
            >
                <Alert onClose={() => setSnack(prev => ({ ...prev, open: false }))} severity={snack.severity} sx={{ width: '100%' }}>
                    {snack.message}
                </Alert>
            </Snackbar>
        </>
    );
}

export default Stage3InviteCandidates
